import axiosInstance from './apiConfig';

// Fetch all lands with optional search query
export const getAllLands = async (search?: string) => {
  try {
    const response = await axiosInstance.get('/land/getAll', {
      params: {
        ...(search && search.length > 0 ? { search } : {}),
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch lands ${error.response?.data?.error || error}`,
    );
  }
};

// Fetch land by its ID
export const getLandById = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/land/getById`, {
      params: { id },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch land by id ${error.response?.data?.error || error}`,
    );
  }
};

// Fetch lands by registration id (parent registration)
export const getLandsByRegistrationId = async (registrationId: string) => {
  try {
    const response = await axiosInstance.get(`/land/getByRegistrationId`, {
      params: { registrationId },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch lands ${error.response?.data?.error || error}`,
    );
  }
};

// Fetch unregistered lands by organization id
export const getUnregisteredLandsByOrganizationId = async (
  organizationId: string,
) => {
  try {
    const response = await axiosInstance.get(`/land/getUnregisteredByOrgId`, {
      params: { organizationId },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Failed to fetch unregistered lands ${error.response?.data?.error || error}`,
    );
  }
};

// Add a new land
export const addNewLand = async (data: any) => {
  try {
    const response = await axiosInstance.post('/land/add', data);
    return response.data;
  } catch (error: any) {
    throw new Error(`Add land failed ${error.response?.data?.error || error}`);
  }
};

// Update existing land
export const updateLand = async (id: number, data: any) => {
  try {
    const response = await axiosInstance.put(`/land/update?id=${id}`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Update land failed ${error.response?.data?.error || error}`,
    );
  }
};

// Delete land
export const deleteLand = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/land/delete?id=${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      `Delete land failed ${error.response?.data?.error || error}`,
    );
  }
};

export const exportLands = async (
  organizationId: number,
  category?: string,
  registrationId?: number,
): Promise<Blob> => {
  try {
    let url = `/land/export?organizationId=${organizationId}`;

    if (category) {
      url += `&category=${encodeURIComponent(category)}`;
    }

    if (registrationId) {
      url += `&registrationId=${registrationId}`;
    }

    const response = await axiosInstance.get(url, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error: any) {
    throw new Error(
      `Export land failed ${error.response?.data?.error || error}`,
    );
  }
};

export const uploadLands = async (file: File) => {
  const data = new FormData();
  data.append('file', file);

  try {
    const response = await axiosInstance.post('/land/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error;
  }
};
